import React, { } from 'react';
import { Col } from 'reactstrap';
import { InputText } from 'primereact/inputtext';
import { Repeat } from 'react-feather';



export const TitleDataTable = (props) => {

    const { titleTable, buttonActions, titleButton, isDisbled = false, loadingIsDisabled = false,
        titleCreate, buttonActionsCreate, actionInput, valueFilter, filterLocalStorage = false, cleanFilterLocalStorage,
        extraButton = false, onExtraButtonClick, extraButtonDisabled = false, extraButtonLabel = "Reporte", titleReport,
        showExportButton = true, microsite= false, buttonMicrosite = () => {}, titleButtonMicrosite, showCreateButton = true, 
        tranferButton = false, buttonTransfire = () => {}, titleButtonTransfire,
        uploadButton=false,
        buttonUpload=()=>{},
        titleButtonUpload="Carga archivo csv"

    } = props;

    return (
        <>
            <Col sm="12" className='p-l-0 p-r-0' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                <div className='ribbon ribbon-clip ribbon-primary' style={{ position: 'static' }}>
                    {titleTable ?? ""}
                </div>

                <div className="d-flex" style={{ gap: "6px" }}>
                    {showCreateButton && (
                        <button
                            className="p-button p-button-primary"
                            onClick={() => buttonActionsCreate()}
                            title={titleCreate ?? ""}
                            style={{
                                alignItems: "center",
                                padding: "5px 8px",
                                height: "35px",
                                width: "35px",
                                fontSize: "0.9rem",
                                display: "flex",
                                justifyContent: "center",
                                position: "relative",
                            }}
                        >
                            <i className="fa fa-plus-circle" style={{ fontSize: "1rem" }}></i>
                        </button>
                    )}
                   {showExportButton && (
                        <button
                            className="p-button p-button-success"
                            onClick={buttonActions}
                            title={titleButton ?? ""}
                            style={{
                                alignItems: "center",
                                padding: "5px 8px",
                                height: "35px",
                                width: "35px",
                                fontSize: "0.9rem",
                                display: "flex",
                                justifyContent: "center",
                                position: "relative"
                            }}
                            disabled={isDisbled}
                        >
                            {isDisbled ? (
                                loadingIsDisabled ? (
                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: "1rem" }}></i>
                                ) : (
                                    <i className="pi pi-file-excel" style={{ fontSize: "1rem" }}></i>
                                )
                            ) : (
                                <i className="pi pi-file-excel mr-1" style={{ fontSize: "1rem" }}></i>
                            )}
                        </button>
                    )}


                    {extraButton && (
                        <button
                            className="p-button p-button-warning"
                            onClick={onExtraButtonClick}
                            disabled={extraButtonDisabled}
                            title={titleReport ?? ""}
                            style={{
                            alignItems: "center",
                                padding: "5px 8px",
                                height: "35px",
                                width: "130px",
                                fontSize: "0.9rem",
                                display: "flex",
                                justifyContent: "center",
                                position: "relative"
                            }}
                        >
                            {extraButtonDisabled ? (
                                <>
                                    <i className="pi pi-spin pi-spinner mr-1"></i>
                                    Cargando...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-file-excel-o mr-1"></i>
                                    {extraButtonLabel}
                                </>
                            )}
                        </button>
                    )}

                     {microsite && (
                        <button
                            className="p-button"
                            onClick={buttonMicrosite}
                            title={titleButtonMicrosite ?? ""}
                            style={{
                                alignItems: "center",
                                padding: "5px 8px",
                                height: "35px",
                                width: "35px",
                                fontSize: "0.9rem",
                                display: "flex",
                                justifyContent: "center",
                                position: "relative",
                                backgroundColor: '#FF9800',
                                border: '#FF9800'
                            }}
                            disabled={isDisbled}
                        >
                            {isDisbled ? (
                                loadingIsDisabled ? (
                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: "1rem" }}></i>
                                ) : (
                                    <i className="fa fa-picture-o" style={{ fontSize: "1rem" }}></i>
                                )
                            ) : (
                                <i className="fa fa-picture-o mr-1" style={{ fontSize: "1rem" }}></i>
                            )}
                        </button>
                    )}

                    {tranferButton && (
                        <button
                            className="p-button"
                            onClick={buttonTransfire}
                            title={titleButtonTransfire ?? ""}
                            style={{
                                alignItems: "center",
                                padding: "5px 8px",
                                height: "35px",
                                width: "35px",
                                fontSize: "0.9rem",
                                display: "flex",
                                justifyContent: "center",
                                position: "relative",
                                backgroundColor: '#FF9800',
                                border: '#FF9800'
                            }}
                            disabled={isDisbled}
                        >
                           {isDisbled ? (
                                loadingIsDisabled ? (
                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: "1rem" }}></i>
                                ) : (
                                    <Repeat size={20} />
                                )
                            ) : (
                                <Repeat size={20} />
                            )}
                        </button>
                    )}

                    {uploadButton && (
                        <button
                            className="p-button"
                            onClick={buttonUpload}
                            title={titleButtonUpload}
                            style={{
                                alignItems: "center",
                                padding: "5px 8px",
                                height: "35px",
                                width: "35px",
                                fontSize: "0.9rem",
                                display: "flex",
                                justifyContent: "center",
                                position: "relative",
                                backgroundColor:"#ff9c01",
                                border:"#ff9c01"
                            }}
                        >
                            <i 
                                className="pi pi-upload"
                                style={{fontSize:"1rem"}}
                            />
                        </button>
                    )}
                </div>

                <div className="d-flex" style={{ flex: 1, justifyContent: "flex-end" }}>
                    <span className="p-input-icon-left" style={{ position: "relative", width: "90%", maxWidth: "280px"}}>
                        <InputText
                            type="search"
                            className="pl-6"
                            onInput={(e) => actionInput(e.target.value)}
                            value={valueFilter}
                            style={{ width: "100%" }}
                            placeholder='Búsqueda...'
                        />
                        {filterLocalStorage && valueFilter && (
                            <button
                                onClick={cleanFilterLocalStorage}
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer"
                                }}
                            >
                                <i className="pi pi-times" />
                            </button>
                        )}
                    </span>
                </div>

            </Col>


        </>
    )
}
